/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSignalCast: {
  name: 'temp-signal-cast';
  data: string;
} = {
  name: 'temp-signal-cast',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v3a1 1 0 0 0 2 0V5h14v14h-3a1 1 0 1 0 0 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5ZM4 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1-9a1 1 0 0 1 1-1 9 9 0 0 1 9 9 1 1 0 1 1-2 0 7 7 0 0 0-7-7 1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2 3 3 0 0 1 3 3 1 1 0 1 0 2 0 5 5 0 0 0-5-5Z" fill="currentColor"/></svg>`,
};
